/** PURE_IMPORTS_START ._FromEventPatternObservable PURE_IMPORTS_END */
import { FromEventPatternObservable } from './FromEventPatternObservable';
export var fromEventPattern = FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/fromEventPattern.js
// module id = ./node_modules/rxjs/_esm5/observable/fromEventPattern.js
// module chunks = vendor